import {
  Component,
  ElementRef,
  Input,
  OnInit,
  HostBinding,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { icons } from './icons';
import { v4 as uuidv4 } from 'uuid';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mg-icons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icons.component.html',
})
export class IconsComponent implements OnInit {
  @Input() id = '';
  @Input() applyColor = false;
  @Input() mgTitle: string | undefined;

  @HostBinding('class.tooltip-container') get hasTooltip() {
    return this.mgTitle !== undefined;
  }

  constructor(private element: ElementRef) {}

  ngOnInit() {
    if (!this.id) this.id = `icon-${uuidv4()}`;
  }

  @Input()
  set name(iconName: string) {
    this.element.nativeElement.innerHTML = icons[iconName] || null;
  }

  getIconColorClass(): string {
    if (this.applyColor === true) return `color-${this.name}`;
    return '';
  }
}
